import React from "react";
import PropTypes from "prop-types";

import { Row } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import PageSection from "components/PageSection";
import bioPhoto from "content/assets/images/about/erika.jpeg";

import "./About.scss";

const About = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, header: rootHeader, timeline } = frontmatter;

  return (
    <PageSection className={className} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader}/>
      </Row>
      <Row>
      <div className="bio-container">
          <div className="left-section">
            <img src={bioPhoto} alt="" className="bio-cover" />
          </div>
          <div className="right-section">
          {timeline.map(({ content, content2, header, imageFileName }) => (
            <div key={header}>
            <p>{imageFileName}</p>
            <p>{content}</p>
            <p>{content2}</p>
            </div>
            ))}
          </div>
        </div>
      </Row>
      {/* <Row>
      <div className="service-container">
          <div className="right-section">
          {timeline.map(({ content3, content4, content5, header }) => (
            <div key={header}>
            <p>{content3}</p>
            <p>{content4}</p>
            <p>{content5}</p>
            </div>
            ))}
          </div>
          <div className="left-section">
            <figure>
              <img src={lawaPhoto} alt="" className="bio-cover" />
              <figcaption><a target="_blank" href="https://www.lawanc.org/" rel="noreferrer">Latin Americans Working for Achievement</a> </figcaption>
            </figure> 
          </div>
        </div>
      </Row> */}
     
    </PageSection>
  );
};

About.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

About.defaultProps = {
  className: null,
  frontmatter: null,
};

export default About;
